(function(){
     'use strict';

     angular
        .module('appback')
        .factory('FotopublicacionService', FotopublicacionService);

    FotopublicacionService.$inject = ['$http'];

    function FotopublicacionService($http){

        var service= {
           getPublicaciones:getPublicaciones,
           nuevaPublicacion:nuevaPublicacion,
           buscarEspecie:buscarEspecie,
           getPublicacion:getPublicacion,
           iaCheck:iaCheck,
           iaCheckGeneral:iaCheckGeneral
        };

        return service;

        function iaCheck(rect,fotoSeleccionada,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/fotopublicacion/iafoto', { params : { rect:JSON.stringify(rect),fotoSeleccionada:JSON.stringify(fotoSeleccionada)  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function iaCheckGeneral(fotoSeleccionada,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/fotopublicacion/iafotogeneral', { params : { fotoSeleccionada:JSON.stringify(fotoSeleccionada)  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function buscarEspecie(lims_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/fotopublicacion/buscarespeciebylimsid', { params : { lims_id:lims_id  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function nuevaPublicacion(carta,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               carta:JSON.stringify(carta)
            });
            $http.post('/backend/fotopublicacion/nuevapublicacion', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }


 		function getPublicaciones(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/fotopublicacion/getpublicaciones', { params : {  } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getPublicacion(id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/fotopublicacion/getpublicacion', { params : { id:id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();